import React, { forwardRef, Ref, JSX } from 'react';
import { DataTestIdProp } from '../../../../Models/DataTestIdProp';
import { Button } from 'reactstrap';
import DateDisplay from '../../UI/DateDisplay/DateDisplay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

interface CustomDisplayProps {
  customDateFormat?: boolean;
  firstDate: string;
  secondDate: string;
  onClick?: () => void;
  untilTranslation: string;
  fromTranslation: string;
  displayIcon: boolean;
  displayDuration?: boolean;
  duration: string;
  customDivider?: React.ReactNode;
  disabled?: boolean;
  innerRef?: Ref<HTMLButtonElement>;
}

const DateRangeDisplay = forwardRef(
  (props: CustomDisplayProps & DataTestIdProp, ref: Ref<Button>): JSX.Element => {
    const {
      customDateFormat,
      onClick,
      displayIcon,
      firstDate,
      secondDate,
      untilTranslation,
      fromTranslation,
      dataTestId,
      displayDuration,
      duration,
      customDivider,
      disabled,
      innerRef
    } = props;

    return (
      <Button
        className="iso__date-range-input custom-button"
        color="white"
        onClick={onClick}
        ref={ref}
        data-testid={dataTestId}
        disabled={disabled}
        innerRef={innerRef as (instance: HTMLButtonElement | null) => void | (() => void)}
      >
        <div className="d-flex">
          <div className="w-100 iso__date-range-input_text-container">
            <span className="d-flex">
              <span
                className={`iso__date-range-input_from${
                  !firstDate ? ' iso__date-range-input_from--placeholder' : ''
                }`}
              >
                {!firstDate ? (
                  fromTranslation
                ) : (
                  <DateDisplay customDateFormat={customDateFormat} date={firstDate} />
                )}{' '}
              </span>
              <span className="iso__date-range-input_divider">
                {customDivider ? (
                  customDivider
                ) : (
                  <span>
                    <FontAwesomeIcon icon={faArrowCircleRight} />
                  </span>
                )}
              </span>{' '}
              <span
                className={`iso__date-range-input_until${
                  !secondDate ? ' iso__date-range-input_until--placeholder' : ''
                }`}
              >
                {!secondDate ? (
                  untilTranslation
                ) : (
                  <DateDisplay customDateFormat={customDateFormat} date={secondDate} />
                )}
              </span>
              {!!duration && !duration.startsWith(',') ? `, ` : ''}
            </span>
            {displayDuration && !!duration && (
              <span className="iso__date-range-input_duration">{duration}</span>
            )}
          </div>
          {displayIcon && (
            <div className="ml-3">
              <FontAwesomeIcon icon={faCalendarAlt} />
            </div>
          )}
        </div>
      </Button>
    );
  }
);

export default DateRangeDisplay;
